import { Menu, PopoverVirtualElement } from '@mui/material';
import React, { memo, useState } from 'react';
interface PopupmenuProps {
  children: React.ReactNode;
  anchorElement:
    | Element
    | PopoverVirtualElement
    | (() => Element | PopoverVirtualElement | null)
    | null
    | undefined;
  closeMenu: ((event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void) | undefined;
  className?: string;
}

const Popupmenu = ({ children, anchorElement, closeMenu, className, ...props }: PopupmenuProps) => {
  return (
    <Menu
      sx={{
        minWidth: '250px',
        '.MuiMenuItem-root': {
          minHeight: '50px'
        },
        '.MuiMenuItem-root:Hover': {
          backgroundColor: '#EDECFA'
        },
        '.MuiPaper-root': {
          boxShadow: 'unset',
          border: '2px solid #697885',
          width: 'fit-content'
        }
      }}
      open={Boolean(anchorElement)}
      anchorEl={anchorElement}
      onClose={closeMenu}
      className={className}
      {...props}
    >
      <>{children}</>
    </Menu>
  );
};

export default memo(Popupmenu);
